import { Component, OnInit, ViewEncapsulation, ViewChild, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';


@Component({
    selector:    'master1-number',
    templateUrl: './master1-number-dialog.html',
    styleUrls:  ['./master1-number-dialog.scss'],
  })
  export class Master1NumberDialog {
  
    constructor(
      public dialogMaster1Number: MatDialogRef<Master1NumberDialog>,
      @Inject( MAT_DIALOG_DATA ) public data: any) { }
  
    onNoClick(): void {
      this.dialogMaster1Number.close();
    }
  
  }